import { render, staticRenderFns } from "./TourGroup1x1.vue?vue&type=template&id=57a3101c&scoped=true&"
import script from "./TourGroup1x1.vue?vue&type=script&lang=js&"
export * from "./TourGroup1x1.vue?vue&type=script&lang=js&"
import style0 from "./TourGroup1x1.vue?vue&type=style&index=0&id=57a3101c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a3101c",
  null
  
)

export default component.exports